import type { Answer, UIThreadMessagesItem } from "../../generated/core-api";
import { extractAssistantAnswer } from "./extractAssistantAnswer";

/** Map thread message indices to structured assistant answers. */
export function buildAnswersByMessageIndex(
  messages: UIThreadMessagesItem[],
): Partial<Record<number, Answer>> {
  const answers: Partial<Record<number, Answer>> = {};

  messages.forEach((_message, index) => {
    const answer = extractAssistantAnswer(messages, index);
    if (answer) {
      answers[index] = answer;
    }
  });

  return answers;
}
